<template>
  <div class="holder-table">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <table cellpadding="0" cellspacing="0" border="0">
      <TableHeader>
        <tr>
          <th class="w-300">
            <div
              id="sort_approved_by_name"
              class="table-header-box"
              :class="{
                'sort-active': sortBy === 'firstName',
                'sorted-desc': order === 'desc',
              }"
              @click="sortedBy('firstName')"
            >
              <UserIcon />
              <span class="header-table-text">User Name</span>
              <arrowDown class="arrow" />
            </div>
          </th>
          <th>
            <div
              id="sort_approved_by_roles"
              class="table-header-box"
              :class="{
                'sort-active': sortBy === 'roleName',
                'sorted-desc': order === 'desc',
              }"
              @click="sortedBy('roleName')"
            >
              <PhoneIcon1016 />
              <span class="header-table-text">Role</span>
              <arrowDown class="arrow" />
            </div>
          </th>
          <th>
            <div
              id="sort_approved_by_cases"
              class="table-header-box"
              :class="{
                'sort-active': sortBy === 'countCases',
                'sorted-desc': order === 'desc',
              }"
              @click="sortedBy('countCases')"
            >
              <CaseIcon />
              <span class="header-table-text">Case</span>
              <arrowDown class="arrow" />
            </div>
          </th>
          <th>
            <div
              id="sort_approved_by_date"
              class="table-header-box"
              :class="{
                'sort-active': sortBy === 'requestAt',
                'sorted-desc': order === 'desc',
              }"
              @click="sortedBy('requestAt')"
            >
              <DateIcon16 />
              <span class="header-table-text">Request Date</span>
              <arrowDown class="arrow" />
            </div>
          </th>
          <th>
            <div
              id="sort_accepted_by_date"
              class="table-header-box"
              :class="{
                'sort-active': sortBy === 'acceptedAt',
                'sorted-desc': order === 'desc',
              }"
              @click="sortedBy('acceptedAt')"
            >
              <DateIcon16 />
              <span class="header-table-text">Accepted Date</span>
              <arrowDown class="arrow" />
            </div>
          </th>
        </tr>
      </TableHeader>
      <Loader v-if="loadFlag" :load-flag="loadFlag" />
      <template v-else>
        <ApprovedNewItem
          v-if="approvedList.length"
          :approved-list="approvedList"
          @deactivateUser="confirmDeactivateUser"
        />
        <p v-if="!approvedList.length" class="not-found">
          No invitations found, you can
          <span @click="$router.push({name: 'Send invitations'})">invite new contact</span>
          {{ isAnyFilterApplied ? 'or' : '' }}
          <span v-if="isAnyFilterApplied" @click="$emit('resetFilters')"> reset filters</span>
        </p>
      </template>
    </table>
    <pagination
      v-if="approvedList.length && count !== 1"
      v-model="page"
      :total-pages="count"
      :link-gen="linkGen"
    />
    <CommonDialog
      ref="commonDialogResendUser"
    >
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Invitations were successfully resent!
      </p>
    </CommonDialog>
    <CommonDialog
      ref="commonDialogDeleteUser"
    >
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Selected users were deactivated
      </p>
    </CommonDialog>
    <InfoDialog
      ref="infoDialog"
      :title="infoDialogData.dialogTitle || ''"
      :text="infoDialogData.dialogText || ''"
      :confirm-btn-text="infoDialogData.confirmBtnText || ''"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deactivateUser"
    />
  </div>
</template>

<script>
import InfoDialog from '../popups/InfoDialog';
import ApprovedNewItem from './ApprovedNewItem';
import TableHeader from '../table/TableHeader';
import CommonDialog from '../popups/CommonDialog';
import AlertErrorMsg from '../profile/AlertErrorMsg';
import {createDeactivateDialog} from '@/constants/infoDialogData';
import linkGenerator from '../../constants/linkGen';
import ArrowDown from '../icons/ArrowDown';
import UserIcon from '../icons/UserIcon';
import CaseIcon from '../icons/CaseIcon';
import Loader from '../loader/Loader';
import Pagination from '@/components/common/Pagination.vue';
import errorHandler from '@/mixins/errorHandler';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import DateIcon16 from '@/components/icons/DateIcon16.vue';
import PhoneIcon1016 from '@/components/icons/PhoneIcon1016.vue';

export default {
  name: 'Approved',
  components: {
    PhoneIcon1016,
    DateIcon16,
    SuccessIcon,
    Pagination,
    Loader,
    CaseIcon,
    UserIcon,
    ArrowDown,
    TableHeader,
    ApprovedNewItem,
    CommonDialog,
    InfoDialog,
    AlertErrorMsg
  },
  mixins: [errorHandler],
  props: {
    searchText: {
      type: String
    },
    requestDate: {},
    acceptDate: {},
  },
  data() {
    return {
      infoDialogData: {
        dialogTitle: '',
        dialogText: '',
        confirmBtnText: '',
        cancelBtnText: '',
      },
      el: {
        isActive: true
      },
      margin0: 'm-0',
      type: 'approved',
      page: 1,
      size: 10,
      count: 0,
      pageSize: 2,
      sortBy: 'acceptedAt',
      order: 'desc',
      approvedList: [],
      casesList: [],
      userMail: '',
      loadFlag: false,
      errorMessage: '',
      requestDateRange: null,
      acceptDateRange: null,
    };
  },
  computed: {
    isAnyFilterApplied() {
      return this.searchText || this.requestDate || this.acceptDate;
    },
  },
  watch: {
    searchText() {
      this.getInviteUser();
    },
    requestDate(value) {
      const requestDateFrom = isNaN(Date.parse(value[0])) == false ? Date.parse(value[0]) : '';
      const requestDateTo = isNaN(Date.parse(value[1])) == false ? Date.parse(value[1]) : '';
      this.requestDateRange = requestDateFrom + ' ' + requestDateTo;
      this.page = 1;
      this.getInviteUser();
    },
    acceptDate(value) {
      const acceptDateFrom = isNaN(Date.parse(value[0])) == false ? Date.parse(value[0]) : '';
      const acceptDateTo = isNaN(Date.parse(value[1])) == false ? Date.parse(value[1]) : '';
      this.acceptDateRange = acceptDateFrom + ' ' + acceptDateTo;
      this.page = 1;
      this.getInviteUser();
    },
    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.page = newVal;
          this.getInviteUser();
        } else {
          this.page = 1;
        }
      }
    }
  },
  mounted() {
    this.page = this.$route.query.page || 1;
    this.getInviteUser();
  },
  methods: {
    openDeactivatePopupUser() {
      this.$refs.commonDialogDeleteUser.openPopups();
    },
    linkGen(pageNum) {
      return linkGenerator(pageNum, '/invite-new-contact/approved');
    },
    sortedBy(filterName) {
      this.order = filterName === this.sortBy && this.order === 'desc' ? 'asc' : 'desc';
      this.sortBy = filterName;
      this.getInviteUser();
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
      });
    },
    getInviteUser() {
      this.$load(async () => {
        this.loadFlag = true;
        await this.$api.invites.getInvite({
          type: this.type,
          page: this.page,
          size: this.size,
          sortBy: this.sortBy,
          order: this.order,
          searchKey: this.fixedEncodeURIComponent(this.searchText),
          requestDate: this.requestDateRange || '',
          acceptDate: this.acceptDateRange || '',
        }).then((res) => {
          this.approvedList = res.data.body.content;
          this.count = res.data.body.totalPages;
          this.pageSize = res.data.body.size;
        }, (error) => {
          this.handleResponseError(error);
        });
        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      });
    },
    confirmDeactivateUser(user) {
      this.infoDialogData = createDeactivateDialog('contact');
      this.$refs.infoDialog.openPopup(user);
    },
    deactivateUser(item) {
      this.$load(async () => {
        await this.$api.contacts.deactivateUser(item.publicId).then(() => {
          this.$refs.infoDialog.closePopup();
          this.openDeactivatePopupUser();
          this.getInviteUser();
        }, (error) => {
          this.handleResponseError(error);
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.dialog-message-description {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #696F79;
  display: block;
  width: 100%;
}

.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 20px 0;
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  font-size: 16px;
  font-weight: 500;
  line-height: 25.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--light-gray);

  span {
    color: var(--accent-color);
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
